import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";

// Icons
import PersonIcon from '@mui/icons-material/Person';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

import { cores } from '../styles/styleUtils';

// Modal
import AddProposta from '../pages/AddProposta'

const Container = styled.div`
  border-radius: 12px;
  border: 0.5px solid #E2E4E8;
  border-left: 4px solid ${(props) => (props.isDragging ? cores.laranja : (props.backgroundColor || cores.cinzaMedio))};
  padding: 10px 14px;
  color: ${cores.chumbo};
  margin: 0 10px 10px;
  min-height: 90px;
  background-color: ${cores.branco};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const Nome = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${cores.chumbo};
  margin: 0 0 8px;
`;

const Linha = styled.p`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${cores.cinzaMedio};
  margin: 0 0 4px;

  svg {
    font-size: 15px;
    color: ${cores.cinzaMedio};
  }
`;

const Rodape = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
`;

const Valor = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${cores.chumbo};
`;

const Pill = styled.span`
  font-size: 12px;
  font-weight: 500;
  border-radius: 10px;
  padding: 2px 10px;
  background-color: ${(props) => (props.rejeitado ? '#FCEBEB' : '#EAF3DE')};
  color: ${(props) => (props.rejeitado ? '#791F1F' : '#3B6D11')};
`;

export default function Task({ task, index, columnColor, onConfirm }) {
  const [produto, setProduto] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleDoubleClickTable = (row,index) => {
    setProduto({...row, index})
    setOpen(true)
  };

  const handleClose = () => {
    setOpen(false)
    setProduto(null)
  };


  return (
    <>
    
    <Draggable draggableId={`${task.id}`} key={task.id} index={index}>
      {(provided, snapshot) => (
        <Container
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
          backgroundColor={columnColor}
          onDoubleClick={() => handleDoubleClickTable(task,index)}
        >
          <div>
            <Nome>
              <PersonIcon fontSize="inherit" style={{ marginRight: 6, verticalAlign: 'middle', color: cores.cinzaMedio }} />
              {task.cliente?.nome}
            </Nome>

            <Linha>
              <ProductionQuantityLimitsIcon />
              {task.produto?.nome}
            </Linha>

            <Linha>
              <CalendarMonthIcon />
              {new Date(task.data).toLocaleDateString()}
            </Linha>

            <Linha>
              <AddLocationAltIcon />
              {task.localinstalacao?.cidade?.nome}
            </Linha>

            <Linha>
              <PersonIcon />
              {task.user?.nome}
            </Linha>
          </div>

          <Rodape>
            {
              task.valor &&
                <Valor>
                  <AttachMoneyIcon fontSize="inherit" style={{ verticalAlign: 'middle', color: cores.cinzaMedio }} />
                  {parseFloat(task.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </Valor>
            }

            {
              task.finalizado?.nome &&
                <Pill rejeitado={task.finalizado.nome === 'Rejeitado'}>
                  {task.finalizado.nome}
                </Pill>
            }
          </Rodape>
          {provided.placeholder}
        </Container>
      )}
    </Draggable>
    {
      open && <AddProposta open={open} proposta={produto} onClose={handleClose} onConfirm={onConfirm} />
    }
    
    </>
    
  );
}